export default {
  namespaced: true,
  state: {
    isNewChatOpen: false,
    unreadMessagesCount: 0,
    preSelectedChatId: null,
    autoMessage: null, // { text: string, files: File[] }
    targetGroup: null, // 'payor' | 'operator' | null
  },
  mutations: {
    SET_NEW_CHAT_OPEN(state, isOpen) {
      state.isNewChatOpen = isOpen;
    },
    SET_UNREAD_MESSAGES_COUNT(state, unreadMessagesCount) {
      state.unreadMessagesCount = unreadMessagesCount;
    },
    SET_PRE_SELECTED_CHAT_ID(state, preSelectedChatId) {
      state.preSelectedChatId = preSelectedChatId
    },
    SET_AUTO_MESSAGE(state, autoMessage) {
      state.autoMessage = autoMessage;
    },
    SET_TARGET_GROUP(state, targetGroup) {
      state.targetGroup = targetGroup;
    }
  },
  actions: {
    toggleNewChat({ commit, state }) {
      commit("SET_NEW_CHAT_OPEN", !state.isNewChatOpen);
    },
    openNewChatModal({ commit }) {
      commit("SET_NEW_CHAT_OPEN", true);
      commit("SET_PRE_SELECTED_CHAT_ID", '');
    },
    closeNewChatModal({ commit }) {
      commit("SET_NEW_CHAT_OPEN", false);
    },
    setPreSelectedChatId({ commit }, selectedChatId) {
      commit('SET_PRE_SELECTED_CHAT_ID', selectedChatId)
    },
    setAutoMessage({ commit }, autoMessage) {
      commit('SET_AUTO_MESSAGE', autoMessage);
    },
    clearAutoMessage({ commit }) {
      commit('SET_AUTO_MESSAGE', null);
    },
    setTargetGroup({ commit }, targetGroup) {
      commit('SET_TARGET_GROUP', targetGroup);
    },
    clearTargetGroup({ commit }) {
      commit('SET_TARGET_GROUP', null);
    }
  },
};
